const AccommTripItems = document.querySelector('.multi-trips-using');

const accommTrips = () => {
	// load more.
	if (AccommTripItems) {
		let currentCount = 4;
		if (AccommTripItems.classList.contains('multi-trips-using--block')) {
			currentCount = 8;
		}

		const moreTripBtn = document.querySelector(
			'.multi-trips-using .c-btn.c-btn--secondary'
		);

		const tripSlides = document.querySelectorAll(
			'.multi-trips-using .extend-your-trip__slide'
		);

		if (moreTripBtn) {
			moreTripBtn.addEventListener('click', function () {
				currentCount += 4;
				const currentSelections = document.querySelectorAll(
					`.multi-trips-using .extend-your-trip__slide:nth-child(-n+${currentCount})`
				);
				currentSelections.forEach((element) => {
					element.classList.add('active');
				});

				if (currentCount >= tripSlides.length) {
					document
						.querySelector('.multi-trips-using__btn')
						.classList.add('remove');
				}
			});
		}
	}
};

// GLOBAL APP CONTROLLER
const controller = {
	init() {
		accommTrips();
	},
	loaded() {},
	resized() {},
	scrolled() {},
	keyDown() {},
	mouseUp() {},
};

export { controller };
